const palette = {
  primary: {
    base: '#ECEBEB',
    hero: {
      leafGreen: '#3A4D41',
      royalPurple: '#380F91',
    },
    highlight: {
      dutchOrange: '#FF7200',
      dutchOrangeShade: '#FFDFC6',
      hydroGreen: '#0CC988',
      hydroGreenShade: '#C9F3E4',
    },
  },
  functional: {
    white: '#FFFFFF',
    black: '#000000',
    lightGrey: '#F2F2F2',
    grey: '#CCCCCC',
    darkGrey: '#606060',
    leafGreenShade: '#D3D7D4',
    alertRed: '#E6091C',
    alertRedShade: '#F9C8CC',
    darkOrange: '#F06B00',
    lightOrange: '#F06B002B',
    yellow: '#F5AD0F',
    yellowShade: '#FCECC9',
    royalPurpleShade: '#D2C9E6',
  },
}

export const RfhColors = {
  alertRed: palette.functional.alertRed,
  alertRedShade: palette.functional.alertRedShade,
  black: palette.functional.black,
  darkGrey: palette.functional.darkGrey,
  dutchOrange: palette.primary.highlight.dutchOrange,
  dutchOrangeShade: palette.primary.highlight.dutchOrangeShade,
  fogWhite: palette.primary.base,
  hydroGreen: palette.primary.highlight.hydroGreen,
  hydroGreenShade: palette.primary.highlight.hydroGreenShade,
  leafGreen: palette.primary.hero.leafGreen,
  leafGreenShade: palette.functional.leafGreenShade,
  lightGrey: palette.functional.lightGrey,
  grey: palette.functional.grey,
  royalPurple: palette.primary.hero.royalPurple,
  royalPurpleShade: palette.functional.royalPurpleShade,
  white: palette.functional.white,
  darkOrange: palette.functional.darkOrange,
  lightOrange: palette.functional.lightOrange,
  yellow: palette.functional.yellow,
  yellowShade: palette.functional.yellowShade,
}
